<template>
  <div class="trainingrelease">
    <el-form :model="trainingForm" :rules="rules" ref="trainingForm" label-width="120px" style="width: 100%">
      <el-form-item label="培训主题" prop="trainName" style="width:400px;">
        <el-input v-model.trim="trainingForm.trainName" clearable :disabled="isNew==2?true:false" maxlength="20" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="培训封面图" prop="trainCover" style="width:600px;">
        <el-col :span="7">
          <div class="cover">
            <el-upload
                v-loading="trainload"
                :disabled="isNew==2?true:false"
                :auto-upload="true"
                class="avatar-uploader"
                :action="actionUrl"
                :headers="{Authorization:Authorization}"
                name="images"
                :show-file-list="false"
                :before-upload="handlebeforeupload"
                :on-success="handleAvatarSuccess"
                accept="image/jpeg,image/gif,image/png"
                list-type="picture-card"
            >
              <img v-if="trainingForm.trainCover" :src="trainingForm.trainCover" class="el-upload--picture-card" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="11" :offset="1">
          <p style="line-height: 26px;">说明：请发布与网站主题相关的图片，图片大小需控制在500K以内文件格式请用.jpg .png .jpeg图片尺寸建议：2.35:1</p>
        </el-col>
      </el-form-item>


      <el-form-item label="培训类型" style="width:600px;">
        <el-radio-group v-model="trainingForm.trainMethod">
          <el-radio label="1">线上</el-radio>
          <el-radio label="2">线下</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item v-if="trainingForm.trainMethod == 2" label="报名时间" style="width:600px;">
         <el-date-picker v-model="time" 
         @change="changeDataw" 
         type="datetimerange" 
         value-format="yyyy-MM-dd HH:mm:ss" 
         format="yyyy-MM-dd HH:mm:ss"
         :default-time="['00:00:00', '23:59:59']"
         range-separator="至" 
         start-placeholder="开始日期" 
         end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item v-if="trainingForm.trainMethod == 2" label="培训地址" style="width:600px;">
         <el-input v-model="trainingForm.trainAddress"></el-input>
      </el-form-item>

      <el-form-item label="培训介绍" prop="trainIntroduction" style="width:600px;">
        <el-input type="textarea" v-model.trim="trainingForm.trainIntroduction" clearable :disabled="isNew==2?true:false" maxlength="200" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="培训对象" prop="trainObjName" style="width:800px;">
        <div style="display: inline-block;width: 320px;border: 1px solid #DCDFE6;padding: 0 15px;border-radius: 5px;" v-if="trainingForm.trainObjName.length>0">
          <p style="display: inline-block;">
            <label v-for="(item,index) in trainingForm.trainObjName" 
            style="font-size:12px;background: #dfdfdf;border-radius: 500px;padding: 2px 10px;margin-right: 5px;" v-if="index<2">{{item}}</label>
          </p>
          <span style="font-size:12px;background: #dfdfdf;border-radius: 500px;padding: 2px 10px;margin-right: 5px;" v-if="trainingForm.trainObjName.length>2">+{{trainingForm.trainObjName.length-2}}</span>
        </div>
        <el-input v-else placeholder="点击右侧按钮选择对象" readonly style="width: 300px"></el-input>
        <el-button type="primary" style="margin-left: 30px" @click="openUnit" :disabled="isNew==2?true:false">选择对象</el-button>
      </el-form-item>

      <el-form-item label="培训对象年级" style="width:400px;" v-if="trainingForm.trainRole=='1058'">
        <el-select v-model="trainingForm.trainGrades" clearable multiple placeholder="请选择培训对象年级" :disabled="isNew==2?true:false">
          <el-option v-for="item in gradeData" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="培训课程" style="width:400px;" prop="courseIds">
        <el-select v-model="trainingForm.courseIds" multiple clearable filterable :disabled="isNew==2?true:false"  :filter-method="searchcourse" placeholder="请选择" @change="ChangeCourse">
          <el-option v-for="item in CourseDate" :key="item.courseId" :label="item.courseName" :value="item.courseId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-table :data="trainingListData" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" style="width: 100%">
          <el-table-column prop="courseName" label="课程名称"></el-table-column>
          <el-table-column prop="videos" label="章节数"></el-table-column>
          <el-table-column prop="hours" label="课时数"></el-table-column>
          <el-table-column prop="teacherName" label="培训老师"></el-table-column>
          <el-table-column label="视频总时长">
            <template v-slot="scope">
            {{scope.row.chapterVideoHours?Math.floor(scope.row.chapterVideoHours/60)+"分"+scope.row.chapterVideoHours%60+'秒':"0分0秒"}}
          </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <span class="operateitem" @click="clickexam(scope.row,2)">维护课程</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="培训日期" prop="trainingdata" style="width:400px;">
        <el-date-picker 
        v-model="trainingdata" 
        @change="changeData" 
        type="datetimerange" 
        value-format="yyyy-MM-dd HH:mm:ss" 
        format="yyyy-MM-dd HH:mm:ss" 
         :default-time="['00:00:00', '23:59:59']"
        range-separator="至" 
        start-placeholder="开始日期" 
        end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="培训试卷" style="width:600px;">
        <el-select v-model="trainingForm.examId" placeholder="请选择培训课程" @change="Changeexam" :disabled="isNew==2?true:false">
          <el-option v-for="item of examData" :label="item.examTitle" :value="item.examId"></el-option>
        </el-select>
        <el-button type="primary" :disabled="isNew==2?true:false" @click="clickexam('',0)" style="margin-left: 30px">新增试卷</el-button>
      </el-form-item>

      <el-form-item>
        <el-table :data="examDataList" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" style="width: 100%">
            <el-table-column prop="examTitle" label="试卷名称"></el-table-column>
            <el-table-column prop="examRadioNum" label="单选题"></el-table-column>
            <el-table-column prop="examMultipleNum" label="多选题"></el-table-column>
            <el-table-column prop="examQuestionNum" label="问答题"></el-table-column>
            <el-table-column prop="createBy" label="最近更新者"></el-table-column>
            <el-table-column prop="createTime" label="更新时间"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <span class="operateitem" @click="clickexam(scope.row,1)">维护试卷</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="培训附件">
        <el-upload 
        class="upload-demo" 
        ref="upload" 
        :action="actionUrl" 
        :headers="{Authorization:Authorization}"
        :on-preview="annexhandlePreview"
        :before-upload="annexhandleBeforeUpload"
        :on-success="annexhandlesuccesss" 
        :on-remove="annexhandleRemove" 
        name="images" 
        :file-list="trainingForm.annexes" :auto-upload="true">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <div slot="tip" class="el-upload__tip"></div>
        </el-upload>
      </el-form-item>

      <el-form-item style="text-align: center">
        <el-button type="primary" @click="submitForm('trainingForm')" :disabled="isNew==2?true:false">提交</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>

    </el-form>
<!--  选择对象  -->
    <el-drawer :size="600" class="trainingreleasedrawer" :show-close="false" :visible.sync="trainingreleasedrawer">
      <p class="title">选择培训对象<span></span></p>
      <el-form style="padding: 0 30px;">
        <el-form-item>
          <el-input v-model="ChildParam.DeptName" placeholder="请输入学院名称查询" clearable style="width: 230px;margin-right: 10px;"></el-input>
          <el-button type="primary" @click="searchtree">查询</el-button>
          <el-button type="primary" @click="confirm">确认</el-button>
        </el-form-item>
        <el-form-item label="培训角色">
          <el-select v-model="trainingForm.trainRole" clearable placeholder="请选择">
            <el-option v-for="item in trainingrolelist" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-tree 
             ref="dialog" 
             @check-change="check" 
             :check-strictly="isCheck" 
             :data="data" 
             show-checkbox  
             highlight-current 
             :props="defaultProps" 
             :default-checked-keys="murenxianshi" 
             :filter-node-method="filterNode"
             node-key="DeptID"></el-tree>
        </el-form-item>
      </el-form>
    </el-drawer>

  </div>
</template>
<script>
export default ({
  name:'trainingrelease',
  data(){
    return{
      trainingdata:[],
      time:[],
      annexfileList:[],
      Authorization:sessionStorage.getItem('Authorization'),
      actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
      rules: {
        trainName: [{ required: true, message: '请输入培训主题', trigger: 'blur' }],
        trainCover:[{required:true,message:'请上传封面',trigger:'change'}],
        trainIntroduction: [{ required: true, message: '请输入培训介绍', trigger: 'blur' }],
        trainObjName:[{required:true,message:'请点击右侧选择对象',trigger:'change'}],
        trainGrades:[{required:true,message:'请选择培训年级',trigger:'change'}],
        courseIds:[{required:true,message:'请选择培训课程',trigger:'change'}],
        trainingdata: [{ required: true, message: '请选择培训日期', trigger: 'change' }]
      },
      trainId:'',
      isNew:'',
      trainload:false,
      trainingForm:{
        courseIds:[],
        trainObjIds:[],
        trainRole:'',
        trainName: '',
        trainCover:'',
        trainIntroduction: '',
        trainObjName:[],
        trainGrades:[],
        trainStartTime:'',
        trainEndTime:'',
        examId:'',
        trainingdata:[],
        time:[],

        annexes:[],
        trainMethod:'1',
        trainAddress:'',
        enrollStartDate:'',
        enrollEndDate:'',
      },
      gradeData:[],
      trainingListData:[],
      courseparam:{
        pageNum:1,
        pageSize:10,
        courseName:''
      },
      CourseDate:'',
      examParam:{
        pageNum:1,
        pageSize:10,
        examTitle:''
      },
      examData:[],
      examDataList:[],
    //   选择培训对象弹窗
      trainingreleasedrawer:false,
      isCheck:false,
      data:[],
      defaultProps: {children: 'children',label: 'label'},
      murenxianshi:[],
      ChildParam:{
        DeptID:'',
        DeptName:''
      },
      trainingrolelist:[{
        value: '1058',
        label: '学生'
      }, {
        value: '1063',
        label: '心理辅导员(负责人)'
      },{
        value: '1089',
        label: '心理辅导员'
      }, {
        value: '1071',
        label: '心理委员'
      },{
        value: '1079',
        label: '心理联络员'
      },{
        value: '1090',
        label: '导师'
      }],
      trainingrole: '',
      zonglist:'',
      first:true,
      EchoTree:[],
      examParams:{
        examType:1,
        pageNum:1,
        pageSize:20
      },
    }
  },
  // beforeRouteLeave(to,from,next){
  //   to.meta.keepAlive = false
  //   next()
  // },
  watch:{
    'trainingForm.annexes'(newval,oldval){
      if(newval!=null){
        for(let item of newval){
          const lastIndexOfDot = item.annexUrl.lastIndexOf('.');  
          const lastIndexOfSlash = item.annexUrl.lastIndexOf('/'); 
          item.name=item.annexUrl.substring(lastIndexOfSlash + 1, lastIndexOfDot);
          // item.name=item.annexUrl.split('\\')[1]
        }
      }
    }
  },
  activated() {
    this.trainId=this.$route.query.trainId
    this.isNew=this.$route.query.isNew;
    this.trainingForm.annexes=[];
    // this.CourseDate=[];
    this.trainingListData=[];
    // this.examDataList=[];
    // this.examData=[];
    this.querydep();
    this.GetDictionary();
    this.Getcourese();
    this.getexamlist();
    if(this.trainId){
      this.getDetail();
      this.$refs["trainingForm"].resetFields();
    }else{
      if(this.$cookies.get('releaseclear')==0){
        this.trainingForm=this.$options.data().trainingForm;
        this.time=[];
        this.trainingdata=[];
        this.$refs["trainingForm"].resetFields();
      }
    }
    
  },
  methods:{
    searchtree(){
      this.$refs.dialog.filter(this.ChildParam.DeptName);
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
    // 获取全部单位
    querydep(){
      this.$Http_Post('DepartMent/GetDeptmentByNodeAPP').then(res=>{
        if(res.Code==0){
          this.data = res.Data
        }
      })
    },

    // 获取年级
    GetDictionary(){
      this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
        this.gradeData=res.Data;
      });
    },
    // 上传前检查
    handlebeforeupload(file){
      if (file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
        this.trainload=true;
      }else{
        this.$message({type: 'error', message:"请上传正确的图片格式"});
        return false;
      }
    },
    // 上传图片
    handleAvatarSuccess(res, updatafileList) {
      updatafileList['img']=res.Data;
      this.trainingForm.trainCover=res.Data;
      this.trainload=false;
    },
    // 选择日期
    changeData(val){
      if(val==null){
        return false;
      }
      this.trainingForm.trainStartTime=val[0]
      this.trainingForm.trainEndTime=val[1];
      this.trainingForm.trainingdata=val;
      this.trainingdata=val;
    },
    changeDataw(val){
      if(val==null){
        return false;
      }
      
      this.trainingForm.enrollStartDate=val[0]
      this.trainingForm.enrollEndDate=val[1];
      this.trainingForm.time=val;
      this.time=val;
    },

    getSimpleCheckedNodes(store) {//定义数组
      const checkedNodes = []; //判断是否为全选，若为全选状态返回被全选的节点，不为全选状态正常返回被选中的节点
      const traverse = function (node) {
      const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach((child) => {
          if (child.checked) {
            checkedNodes.push(child.data);
          }
          if (child.indeterminate) {
            traverse(child);
          }
        })
      }
      traverse(store)
      return checkedNodes
    },
    check(a, check,b) {//部门点击事件
      this.zonglist = this.getSimpleCheckedNodes(this.$refs.dialog.store);
    },

    // 打开对象弹窗
    openUnit(){
      this.trainingreleasedrawer=true;
      if(this.first){
        this.$nextTick(() => {
          this.first=false;
          this.$refs.dialog.setCheckedNodes(this.EchoTree);
        })
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.trainingForm.trainRole){
            this.Global.request_failure("请选择培训角色")
            return false;
          }
          if(this.trainingForm.trainRole!='1058'){
            delete this.trainingForm.trainGrades;
          }
          let Url=this.isNew==0?'edu/train/add':'edu/train/edit';
          this.trainingForm.trainingdata=this.trainingdata;
          this.trainingForm.time=this.time;
          this.$Http_Post(Url,this.trainingForm).then(res=>{
            if(res.Code==0 || res.Code==200){
              if(this.isNew==0){
                this.trainingdata=[];
                this.CourseDate=[];
                this.trainingListData=[];
                this.examDataList=[];
                this.examData=[];
                this.trainingForm=this.$options.data().trainingForm;
                this.$refs["trainingForm"].resetFields();
                this.$router.go(-1);
              }
              this.$message({type: 'success', message:res.Message});
            }else{
              this.$message({type: 'error', message:res.Message});
            }
          })
        } else {
          this.$message({type: 'error', message:"请填写完整信息"});
          return false;
        }
      });
    },

    confirm(){
      this.trainingForm.trainObjIds=[];
      this.trainingForm.trainObjName=[]
      for(let item of this.zonglist){
        if(this.ChildParam.DeptName=="" && item.fuzi){
          this.trainingForm.trainObjIds.push(item.DeptID);
          this.trainingForm.trainObjName.push(item.DeptName);
        }else{
          this.forchail(item);
        }
        // this.trainingForm.trainObjIds.push(item.DeptID);
        // this.trainingForm.trainObjName.push(item.DeptName);
      };
      this.trainingreleasedrawer=false;
      this.trainingForm.trainObjName;
    },

    // 循环出所有单位
    forchail(val){
      if(val.children.length>0 && val.children[0].DeptID!=-1){
        for(let item of val.children){
          this.forchail(item);
        }
      }else{
        this.trainingForm.trainObjIds.push(val.DeptID);
        this.trainingForm.trainObjName.push(val.DeptName);
      }
    },

    // 获取课程列表
    Getcourese(){
      this.$Http_Post('edu/course/list',this.courseparam).then(res=>{
        if(res.Code==0){
          this.CourseDate=res.Data;
        }else{
          this.$message({type: 'error', message:"获取课程失败"});
        }
      });
    },
    // 搜索课程
    searchcourse(val){
      this.courseparam.courseName=val;
      this.Getcourese();
    },
    // 选中课程
    ChangeCourse(val){
      this.trainingListData=[];
      for(let item of val){
        this.Getchapter(item);
      }
    },
    // 获取章节信息
    Getchapter(val){
      this.trainingListData=[];
      let Hours=0;
      this.$Http_Post('edu/chapter/list',{pageNum:1,pageSize:10,courseId:val}).then(res=>{
        for(let item of res.Data){
              Hours+=item.chapterVideoHours?parseInt(item.chapterVideoHours):0;
        }
        for(let item of this.CourseDate){
          if(val==item.courseId){
            this.trainingListData.push(item);
            this.trainingListData[0]['chapterVideoHours']=Hours;
          }
        }
        
      });
    },

    // 选中培训试卷
    Changeexam(val){
      this.examDataList=[];
      for(let item of this.examData){
        if(item.examId==this.trainingForm.examId){
          this.examDataList.push(item);
        }
      }
    },

    // 查询详情
    getDetail(){
      this.$Http_Get('edu/train/getInfo/'+this.trainId).then(res=>{
        if(res.Code==0 || res.Code==200){
          this.$nextTick(()=>{
            this.trainingForm=res.Data;
            // 如果培训角色不是学生，删除培训年级字段
            if(this.trainingForm.trainRole!='1058'){
              delete this.trainingForm.trainGrades;
            }
            this.trainingForm['trainingdata']=[res.Data.trainStartTime,res.Data.trainEndTime];
            this.trainingdata=[res.Data.trainStartTime,res.Data.trainEndTime];
            this.trainingForm['time']=[res.Data.enrollStartDate,res.Data.enrollEndDate]
            this.time=[res.Data.enrollStartDate,res.Data.enrollEndDate];
            let courseIdArray=res.Data.courseId.split(",");
            this.trainingForm.courseIds=courseIdArray.map(item=>parseInt(item));
            let trainObjIdArray=res.Data.trainObjId.split(",");
            this.trainingForm.trainObjIds=trainObjIdArray.map(item=>(item));
            this.trainingForm.enrollStartDate = res.Data.enrollStartDate
            this.trainingForm.enrollEndDate = res.Data.enrollEndDate
            this.ChangeCourse(this.trainingForm.courseIds);
            this.Changeexam(this.trainingForm.examId);
            this.EchoTree = this.trainingForm.trainObjIds.map((id, index) => ({
              DeptID: id,
              DeptName: this.trainingForm.trainObjName[index]
            }));
          })
        }else{
          this.$message({type: 'error', message:"获取详情失败"});
        }
      })
    },
    // 获取培训试卷列表
    getexamlist(){
      this.$Http_Post('edu/exam/list',this.examParams).then(res=>{
        if(res.Code==0){
          this.examDataList=[];
          this.examData=res.Data;
        }else{
          this.$message({type: 'error', message:"获取试卷列表失败"});
        }
      })
    },
    // 维护试卷
    clickexam(row,num){//0新增试卷 1维护试卷 2维护课程
      this.$cookies.set('releaseclear',1);//不清空
      if(num==0){
        this.$router.push('addtestpaper?isNew=0&trainId='+this.trainId+'&examType=1')
      }else if(num==1){
        this.$router.push('addtestpaper?isNew=1&examType=1&examId='+row.examId)
      }else if(num==2){
        this.$router.push('courseDetail?courseId='+row.courseId)
      }
      
      
    },
    // 上传前
    annexhandleBeforeUpload(file){debugger
      if (file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
        this.trainload=true;
      }else{
        this.$message({type: 'error', message:"请上传正确的图片格式"});
        return false;
      }
    },
    // 附件上传成功
    annexhandlesuccesss(file,fileList){
      if(file.Code==0){
        this.trainingForm.annexes=this.trainingForm.annexes==null?[]:this.trainingForm.annexes
        var urlParts = file.Data.split('.');
        var fileExtension = urlParts[urlParts.length - 1];
        let data={annexType:fileExtension,annexUrl:file.Data};
        this.trainingForm.annexes.push(data);
      }else{
        this.$message({type: 'error', message:res.Message});
      }
      
    },
    // 移除附件
    annexhandleRemove(file, fileLannexesist){
      this.trainingForm.annexes=fileLannexesist;
      if(this.isNew!=0){
        this.submitForm('trainingForm');
      }
    },
    // 点击列表附件
    annexhandlePreview(file){
      window.location.href=file.annexUrl
    }
  },
})
</script>

<style scoped>
.trainingrelease{background: #fff;padding: 30px;}
.operateitem{padding: 0 5px 0 0;color:#0088ff;cursor: pointer}
.trainingreleasedrawer .title{font-size: 22px;padding:0 30px 10px;}
.trainingreleasedrawer .title span{font-size: 16px;color: #333;margin-left:10px;}
</style>